define('TescoMobile_CareHub/js/view/deal-device-stock',['uiComponent', 'ko', 'underscore', 'jquery', 'mage/translate', 'mage/url', 'Magento_Customer/js/customer-data', 'mage/collapsible'], function (Component, ko, _, $, $t, urlBuilder, customerData) {
  'use strict';

  return Component.extend({
    lookupLabel: $t('Check local stock'),
    buttonLabel: $t('Search'),
    placeHolderText: $t('Postcode'),
    storeStockLabel: $t('Instore stock'),
    warehouseStockLabel: $t('Warehouse stock'),
    inStockLabel: $t('In stock'),
    ooStockLabel: $t('Out of stock'),
    moreText: ko.observable('Show more'),
    moreClass: ko.observable('icon-arrow-down'),
    storeList: ko.observableArray([]),
    storeListElement: '.stock-lookup-results',
    errorMessage: ko.observable(''),
    currentStoreStock: ko.observable(0),
    stockClass: ko.observable('in-stock'),
    stockLabel: ko.observable('In stock'),
    isLoading: ko.observable(false),
    isBranchExist: ko.observable(false),
    isStockAlertEnabled: ko.observable(false),
    isStoresLimit: ko.observable(false),
    isMoreOpen: ko.observable(false),
    skusForOptions: null,
    currentSku: null,
    defaults: {
      template: 'TescoMobile_CareHub/deal-device-stock',
      addToCartButtonSelector: '.catalog-product-view .product-add-form button.action.tocart',
      actionBarAddToCartButtonSelector: '.action-bar .action-button .primary',
      imports: {
        stockAlertEnabled: "tm-deal-device:stockAlertEnabled",
        oosAlertUrl: "tm-deal-device:oosAlertUrl",
        warehouseStockStatus: "tm-deal-device:warehouseStockStatus",
        hasDeliverFromWarehouseItems: "tm-deliver-from-warehouse:hasDeliverableItems"
      }
    },
    initialize: function () {
      this._super();
      $('.option-type-device select').on('change', $.proxy(this.updateSelectedProduct, this));
      this.updateSelectedProduct();
      customerData.reload(['case-details']);
      this.inStoreStockAvailable = ko.computed(function () {
        if (this.isBranchExist()) {
          return true;
        }
        this.stockAlertToggle();
        return false;
      }.bind(this));
      this.stockStatuses = ko.computed(function () {
        const addToCartBtnId = $(this.addToCartButtonSelector);
        const actionBarAddToCartButton = $(this.actionBarAddToCartButtonSelector);
        if (this.isBranchExist()) {
          if (this.currentStoreStock() === 0 && this.warehouseStockStatus() === 0) {
            if (!this.isPhoneShop) {
              addToCartBtnId.addClass('disabled');
              actionBarAddToCartButton.addClass('disabled');
            }
          } else {
            addToCartBtnId.removeClass('disabled');
            actionBarAddToCartButton.removeClass('disabled');
          }
        }
        if (this.oosAlertUrl() && this.isPhoneShop) {
          addToCartBtnId.removeClass('disabled');
          actionBarAddToCartButton.removeClass('disabled');
        }
        if (parseInt(this.isPhoneShop) === 1 && this.warehouseStockStatus() === 0 && this.hasDeliverFromWarehouseItems()) {
          addToCartBtnId.addClass('disabled');
          actionBarAddToCartButton.addClass('disabled');
        }
        this.stockAlertToggle();
        if (this.currentStoreStock() > 0 || this.warehouseStockStatus() > 0) {
          this.stockState('in-stock', this.inStockLabel);
          return false;
        }
        this.stockState('oos', this.ooStockLabel);
        return false;
      }.bind(this));
      this.oosAlertUrl.subscribe(this.oosAlertUrlHandler, this);
      return this;
    },
    initObservable: function () {
      this._super();
      this.observe('oosAlertUrl warehouseStockStatus hasDeliverFromWarehouseItems');
      return this;
    },
    oosAlertUrlHandler: function () {
      this.stockAlertToggle();
    },
    stockAlertToggle: function () {
      if (this.stockAlertEnabled === "1" && this.warehouseStockStatus() === 0) {
        this.isStockAlertEnabled(true);
      } else {
        this.isStockAlertEnabled(false);
      }
    },
    collapsibleLookup: function () {
      $('body').trigger('postcodeStockLookupRendered');
      $('#postcode-stock-lookup').collapsible({
        header: 'label.label-stock-lookup',
        content: 'div.form-holder',
        active: false,
        animate: 200
      });
    },
    stockState: function (cssClass, label) {
      this.stockClass(cssClass);
      this.stockLabel(label);
    },
    storeLookup: function () {
      const postCode = $('[name="postcode_stock_lookup"]').val();
      if (postCode.length === 0 || this.currentSku.length === 0) {
        return;
      }
      const self = this;
      const stockLookupUrl = urlBuilder.build('/rest/default/V1/carehub/stockLookup', {});
      self.errorMessage('');
      self.storeList([]);
      self.isLoading(true);
      $.ajax({
        url: stockLookupUrl,
        data: JSON.stringify({
          sku: self.currentSku,
          postCode: postCode
        }),
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      }).done(function (data) {
        self.storeList(data);
        data.length >= 5 ? $(self.storeListElement).addClass('show') && $(self.storeListElement).children('.stock-store').hide().slice(0, 5).show() : $(self.storeListElement).removeClass('show');
      }).fail(function (xhr) {
        var _xhr$responseJSON;
        self.errorMessage(xhr === null || xhr === void 0 || (_xhr$responseJSON = xhr.responseJSON) === null || _xhr$responseJSON === void 0 ? void 0 : _xhr$responseJSON.message);
        $(self.storeListElement).removeClass('show');
      }).always(function () {
        self.isLoading(false);
      });
    },
    updateSelectedProduct: function () {
      let self = this,
        bundleOption = $('[name^="bundle_option"] option:selected'),
        option,
        value;
      if (bundleOption.length === 0) {
        const device = $('.option-type-device .bundle.option');
        if (device.length === 1) {
          option = device.attr("name");
          value = device.val();
        } else {
          return;
        }
      } else {
        const device = bundleOption[0];
        option = $(device).parent().attr('name');
        value = $(device).val();
      }
      const previousSku = this.currentSku;
      if (`${option}_${value}` in this.skusForOptions) {
        this.currentSku = this.skusForOptions[`${option}_${value}`];
      }
      const branchNumber = this.getBranchId();
      if (!branchNumber) {
        self.isBranchExist(false);
        return;
      }
      self.isBranchExist(true);
      const stockLookupByLocationUrl = urlBuilder.build('/rest/default/V1/carehub/stockByLocation', {});
      this.storeList([]);
      if (this.currentSku && this.currentSku !== previousSku && !self.isLoading()) {
        self.isLoading(true);
        $.ajax({
          url: stockLookupByLocationUrl,
          data: JSON.stringify({
            sku: self.currentSku,
            branchNumber: branchNumber
          }),
          type: 'POST',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json'
        }).done(function (data) {
          self.currentStoreStock(data.stock);
        }).fail(function () {
          self.currentStoreStock(0);
        }).always(function () {
          self.isLoading(false);
        });
      }
    },
    getBranchId: function () {
      var _caseDetails;
      const caseDetails = customerData.get('case-details');
      return (_caseDetails = caseDetails()) === null || _caseDetails === void 0 || (_caseDetails = _caseDetails.store) === null || _caseDetails === void 0 ? void 0 : _caseDetails.number;
    },
    showMore: function () {
      const self = this;
      self.isMoreOpen(!self.isMoreOpen());
      self.isMoreOpen() ? this.moreText('Show less') && this.moreClass('icon-arrow-up') : this.moreText('Show more') && this.moreClass('icon-arrow-down');
      self.isMoreOpen() ? $(self.storeListElement).children('.stock-store').show() : $(self.storeListElement).children('.stock-store').hide().slice(0, 5).show();
    }
  });
});

